(function() {
  'use strict';

  // Inject ADDING... button CSS rules immediately
  var styleId = 'fast-path-cart-styles';
  if (!document.getElementById(styleId)) {
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = '\
      button.is-adding,\
      .btn.is-adding,\
      .quick-add__button.is-adding,\
      .add-to-cart-btn.is-adding,\
      [data-add-to-cart].is-adding {\
        background-color: #808080 !important;\
        background: #808080 !important;\
        color: #ffffff !important;\
        border-color: #808080 !important;\
        opacity: 0.9 !important;\
        pointer-events: none !important;\
        cursor: not-allowed !important;\
        box-shadow: none !important;\
      }\
      button.is-adding .btn__text,\
      .btn.is-adding .btn__text,\
      .quick-add__button.is-adding .btn__text,\
      .add-to-cart-btn.is-adding .btn__text,\
      [data-add-to-cart-text].is-adding {\
        color: #ffffff !important;\
        font-weight: 700 !important;\
        text-transform: uppercase !important;\
        letter-spacing: 0.05em !important;\
      }\
      button.is-adding .btn__loader,\
      button.is-adding .btn__plus,\
      button.is-adding .btn__added,\
      button.is-adding svg {\
        display: none !important;\
      }\
    ';
    if (document.head) {
      document.head.appendChild(style);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        document.head.appendChild(style);
      });
    }
  }

  function getCartDrawer() {
    return document.querySelector('#cart-drawer') || document.querySelector('cart-drawer');
  }

  function getCartOverlay() {
    return document.querySelector('.cart_drawer__overlay');
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    var overlay = getCartOverlay();

    if (!drawer) return;

    // Use native theme method if available

 
    if (typeof drawer.openCartDrawer === 'function') {
      drawer.openCartDrawer();
    } else {
      drawer.classList.add('is-open');
      drawer.classList.remove('is-empty');
      if (overlay) {
        overlay.classList.add('active');
      }
      document.body.style.overflow = 'hidden';
      document.documentElement.setAttribute('data-scroll-locked', 'true');
    }

    // Trigger validation if custom.js has loaded
if (checkoutLockActive) {
  forceDisableCheckout();
} else if (typeof window.validateCheckoutState === 'function') {
  try {
    window.validateCheckoutState();
  } catch (e) {}
}
  }

  function closeCartDrawer() {
    var drawer = getCartDrawer();
    var overlay = getCartOverlay();

    if (drawer && typeof drawer.closeCartDrawer === 'function') {
      drawer.closeCartDrawer();
    } else {
      if (drawer) {
        drawer.classList.remove('is-open');
      }
      if (overlay) {
        overlay.classList.remove('active');
      }
      document.body.style.overflow = '';
      document.documentElement.removeAttribute('data-scroll-locked');
    }
  }

  function safelyUpdateItemsHolder(html) {
    if (!html) return false;
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Target ONLY the line items container ([data-items-holder] or <cart-items>)
      var newItemsHolder = doc.querySelector('[data-items-holder]') || doc.querySelector('cart-items');
      var currentItemsHolder = document.querySelector('[data-items-holder]') || document.querySelector('cart-items');

      if (newItemsHolder && currentItemsHolder) {
        currentItemsHolder.innerHTML = newItemsHolder.innerHTML;
      }

      // Update total price if available
      var newPrice = doc.querySelector('.cart__total__price') || doc.querySelector('[data-cart-total]');
      var currentPrice = document.querySelector('.cart__total__price') || document.querySelector('[data-cart-total]');
      if (newPrice && currentPrice) {
        currentPrice.innerHTML = newPrice.innerHTML;
      }

      // Update cart item count badges
      var newCountEl = doc.querySelector('.cart__items-count') || doc.querySelector('[data-cart-count]');
      if (newCountEl) {
        var countText = newCountEl.textContent.trim();
        document.querySelectorAll('[data-cart-count], .cart__items-count').forEach(function(el) {
          el.textContent = countText;
        });
      }

      // Toggle is-empty on drawer container safely
      var drawer = getCartDrawer();
      if (drawer) {
        var hasItems = currentItemsHolder && currentItemsHolder.children.length > 0;
        if (hasItems) {
          drawer.classList.remove('is-empty');
        }
      }

      return true;
    } catch(e) {
      console.warn('Fast-path items update error:', e);
    }
    return false;
  }

  function updateProductCardQuantityUI(variantId, quantity, key, button) {
    if (!variantId && button) {
      variantId = button.getAttribute('data-variant-id') || (button.dataset ? button.dataset.variantId : null);
    }
    if (!quantity) quantity = 1;

    // 1. Hide matching Add To Cart buttons and reveal matching quantity wrappers
    if (variantId) {
      document.querySelectorAll('[data-variant-id="' + variantId + '"].add-to-cart-btn, [data-variant-id="' + variantId + '"][data-add-to-cart]').forEach(function(b) {
        b.classList.add('hide-atc_btn');
      });

      document.querySelectorAll('.quantity-wrapper[data-variant-id="' + variantId + '"]').forEach(function(qw) {
        qw.classList.add('active-qty');
        if (key) {
          qw.setAttribute('data-key', key);
          qw.querySelectorAll('.decrease-cart-qty, .increase-cart-qty').forEach(function(btn) {
            btn.setAttribute('data-key', key);
            btn.setAttribute('data-variant-id', variantId);
          });
        }
        var qtySpan = qw.querySelector('.cart-quantity') || qw.querySelector('.quantity__input');
        if (qtySpan) {
          if (qtySpan.tagName === 'INPUT') {
            qtySpan.value = quantity;
          } else {
            qtySpan.textContent = quantity;
          }
        }
      });
    }

    // 2. Also update parent / scope of the clicked button
    if (button) {
      button.classList.add('hide-atc_btn');
      var parent = button.parentElement || button.closest('.product-item') || button.closest('.product__submit__item');
      if (parent) {
        if (parent.classList.contains('product__submit__item')) {
          parent.classList.add('is-added');
        }
        var localQw = parent.querySelector('.quantity-wrapper');
        if (localQw) {
          localQw.classList.add('active-qty');
          if (key) localQw.setAttribute('data-key', key);
          var localQtySpan = localQw.querySelector('.cart-quantity') || localQw.querySelector('.quantity__input');
          if (localQtySpan) {
            if (localQtySpan.tagName === 'INPUT') {
              localQtySpan.value = quantity;
            } else {
              localQtySpan.textContent = quantity;
            }
          }
        }
      }
    }
  }

var checkoutDisableTimer = null;
var checkoutLockActive = false;

function forceDisableCheckout() {
  var checkoutButtons = document.querySelectorAll('.cart__checkout');

  checkoutButtons.forEach(function(checkoutButton) {
    checkoutButton.classList.add('disabled_checkout');
    checkoutButton.setAttribute('disabled', 'disabled');
    checkoutButton.style.pointerEvents = 'none';
  });
}

function enableCheckoutAfterLock() {
  if (checkoutDisableTimer) {
    clearTimeout(checkoutDisableTimer);
  }

  checkoutDisableTimer = setTimeout(function() {
    checkoutLockActive = false;

    var checkoutButtons = document.querySelectorAll('.cart__checkout');

    checkoutButtons.forEach(function(checkoutButton) {
      checkoutButton.classList.remove('disabled_checkout');
      checkoutButton.removeAttribute('disabled');
      checkoutButton.style.pointerEvents = '';
    });

    checkoutDisableTimer = null;
  }, 4000);
}

function disableCheckoutForThreeSeconds() {
  checkoutLockActive = true;

  forceDisableCheckout();

  if (checkoutDisableTimer) {
    clearTimeout(checkoutDisableTimer);
  }

  /*
   * Keep checkout disabled for at least 3 seconds.
   * Every new cart/freebie update can restart this timer.
   */
  enableCheckoutAfterLock();
}

function refreshCheckoutLock() {
  if (!checkoutLockActive) {
    return;
  }

  forceDisableCheckout();

  if (checkoutDisableTimer) {
    clearTimeout(checkoutDisableTimer);
  }

  enableCheckoutAfterLock();
}

  function setAddingState(button) {
    if (!button) return;
    button.classList.add('is-adding');
    button.disabled = true;
    button.style.pointerEvents = 'none';

    var textSpan = button.querySelector('.btn__text') || button.querySelector('[data-add-to-cart-text]');
    if (textSpan) {
      if (!button.dataset.originalText) {
        button.dataset.originalText = textSpan.textContent;
      }
      textSpan.textContent = 'ADDING...';
    } else {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent;
      }
      button.textContent = 'ADDING...';
    }
  }

  function resetAddingState(button) {
    if (!button) return;
    button.classList.remove('is-adding');
    button.disabled = false;
    button.style.pointerEvents = '';

    var textSpan = button.querySelector('.btn__text') || button.querySelector('[data-add-to-cart-text]');
    if (button.dataset.originalText) {
      if (textSpan) {
        textSpan.textContent = button.dataset.originalText;
      } else {
        button.textContent = button.dataset.originalText;
      }
      delete button.dataset.originalText;
    }
  }

  var isGlobalAddingBusy = false;

  function handleAddToCart(button, form) {
    if (!button && !form) return;

    if (isGlobalAddingBusy || (button && button._isAddingToCart) || (form && form._isAddingToCart)) {
      return;
    }

    if (button && (button.disabled || button.getAttribute('disabled') === 'disabled')) {
      return;
    }

    // Lock to prevent duplicate additions
    isGlobalAddingBusy = true;
    if (button) button._isAddingToCart = true;
    if (form) form._isAddingToCart = true;

    function unlock() {
      setTimeout(function() {
        isGlobalAddingBusy = false;
        if (button) button._isAddingToCart = false;
        if (form) form._isAddingToCart = false;
      }, 800);
    }

    var formData = form ? new FormData(form) : new FormData();

    // Make sure variant ID is present in formData
    var variantId = (button && button.dataset ? button.dataset.variantId : null);
    if (!formData.get('id') && variantId) {
      formData.append('id', variantId);
    }
    if (!formData.get('quantity')) {
      formData.append('quantity', '1');
    }

    // Instantly set ADDING... grey button state
    setAddingState(button);

    disableCheckoutForThreeSeconds();

    var addUrl = (window.routes && window.routes.cart_add_url) || (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) { throw err; });
      }
      return response.json();
    })
    .then(function(data) {
      resetAddingState(button);
      unlock();

      // Update Product Card & PDP quantity counter UI
      var varId = (data && (data.id || data.variant_id)) || (button && button.dataset ? button.dataset.variantId : null);
      var itemQty = (data && data.quantity) ? data.quantity : 1;
      var itemKey = (data && data.key) ? data.key : '';

      updateProductCardQuantityUI(varId, itemQty, itemKey, button);

      // Trigger native theme refresh event
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

      // Fetch api-cart-items section to update items holder without breaking drawer structure
      var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
      fetch(cartUrl + '?section_id=api-cart-items')
        .then(function(res) { return res.text(); })
        .then(function(html) {
          safelyUpdateItemsHolder(html);
          openCartDrawer();
          document.querySelector('cart-items').getCart();
        })
        .catch(function() {
          openCartDrawer();
        });

      // Dispatch product added event
      try {
        document.dispatchEvent(new CustomEvent('theme:product:added', { detail: { button: button, response: data }, bubbles: true }));
      } catch (e) {}
    })
    .catch(function(error) {
      console.error('Fast-path add to cart error:', error);
      resetAddingState(button);
      unlock();
      if (button) {
        var errSpan = button.querySelector('[data-message-error]');
        if (errSpan) {
          errSpan.textContent = error.description || error.message || 'Error adding to cart';
        }
      }
    });
  }

  document.addEventListener('theme:cart:refresh', function() {
  if (checkoutLockActive) {
    refreshCheckoutLock();
  }
});

  // Delegate click events
  document.addEventListener('click', function(e) {
    // Check for drawer close click
    var closeBtn = e.target.closest('[data-cart-drawer-close], .drawer__close, [data-cart-error-close]');
    if (closeBtn) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }

    // Check for Add To Cart button click
    var atcBtn = e.target.closest('[data-add-to-cart], .add-to-cart-btn, button[name="add"], .quick-add__button[type="submit"]');
    if (atcBtn) {
      var form = atcBtn.closest('form');
      e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      handleAddToCart(atcBtn, form);
    }
  }, true); // Use capture phase to intercept before native form POST

  // Delegate submit events for product forms
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var submitBtn = form.querySelector('[data-add-to-cart], button[type="submit"], button[name="add"]');
      handleAddToCart(submitBtn, form);
    }
  }, true);

})();
